import {
    electricPurple000,
    error,
    spanishViridian300,
    spanishViridian500,
} from '@habitech/shared';
import { Paper } from '@mui/material';
import styled from 'styled-components';

export const WrapperAutocomplete = styled.div`
    .loading {
        height: 30px;
        width: 24px;
    }
    .pcom-loading {
        height: 56px;
        display: block;
    }
    .pcom-autocomplete.error {
        fieldset {
            border: solid 1px ${error} !important;
        }
    }
`;
export const PaperStyled = styled(Paper)`
    width: auto;
    .MuiBackdrop-root {
        display: none;
    }
    .MuiPaper-root {
        width: 100%;
    }
    .MuiAutocomplete-listbox::-webkit-scrollbar {
        width: 8px;
    }
    .MuiAutocomplete-listbox::-webkit-scrollbar-thumb {
        border-radius: 20px;
        border: 2px solid ${electricPurple000};
        background-color: ${spanishViridian500};
    }
    .MuiAutocomplete-listbox li:hover,
    .MuiAutocomplete-listbox li[aria-selected='true'] {
        border-left: 2px solid ${spanishViridian500};
        color: ${spanishViridian300};
    }
    .MuiAutocomplete-option[aria-selected='true'] {
        background-color: unset !important;
    }
`;
